import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PatientAdapter } from 'app/core/adapters/patient.adapter';
import { Patient, PatientAPIResponse, patientI } from 'app/core/interfaces/patient';
import { environment } from 'app/environments/environment';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PatientService {
  constructor(
    private http: HttpClient,
    private patientAdapter: PatientAdapter,
  ) {}

  private getHeaders(): HttpHeaders {
    const token = localStorage.getItem('userTokenId');
    return new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });
  }

  public searchByToken(id: string) {
    return this.http.get<Patient>(`${environment.apiUrl}/secretarias-patient/token_id/${id}`, { headers: this.getHeaders() });
  }

  public create(params: any) {
    return this.http.post(`${environment.apiUrl}/secretarias-patient`, params);
  }

  public createNew(patient: Patient): Observable<Patient> {
    const patientFHIR = this.patientAdapter.adaptToAPIFormat(patient);
    patientFHIR.token_id = localStorage.getItem('token_id') ?? '';

    return this.http
      .post<PatientAPIResponse>(`${environment.apiUrl}/secretarias-patient`, patientFHIR)
      .pipe(map((patientFHIR: PatientAPIResponse) => this.patientAdapter.adapterToModel(patientFHIR)));
  }

  public update(id: string, params: patientI) {
    return this.http.put(`${environment.apiUrl}/secretarias-patient/${id}`, params);
  }

  public updateNew(patient_id: string, patient: Patient): Observable<Patient> {
    const patientFHIR = this.patientAdapter.adaptToAPIFormat(patient);
    patientFHIR.token_id = localStorage.getItem('token_id') ?? '';

    return this.http
      .put<PatientAPIResponse>(`${environment.apiUrl}/secretarias-patient/${patient_id}`, patientFHIR)
      .pipe(map((patientFHIR: PatientAPIResponse) => this.patientAdapter.adapterToModel(patientFHIR)));
  }

  public updateBySecretary(patient_id: string, secretary_id: string, patient: any): Observable<Patient> {
    const patientFHIR = this.patientAdapter.adaptToAPIFormat(patient);

    return this.http
      .put<PatientAPIResponse>(`${environment.apiUrl}/secretarias-patient/${patient_id}/secretary/${secretary_id}`, patientFHIR)
      .pipe(map((patientFHIR: PatientAPIResponse) => this.patientAdapter.adapterToModel(patientFHIR)));
  }

  public updateNameByOrganization(patient_id: string, organization_id: string, name: string): Observable<Patient> {
    return this.http
      .put<PatientAPIResponse>(`${environment.apiUrl}/secretarias-patient/${patient_id}/organization/${organization_id}/name`, { name })
      .pipe(map((patientFHIR: PatientAPIResponse) => this.patientAdapter.adapterToModel(patientFHIR)));
  }

  public delete(id: string) {
    return this.http.delete(`${environment.apiUrl}/secretarias-patient/${id}`);
  }

  public show(id: string) {
    return this.http.get(`${environment.apiUrl}/secretarias-patient/${id}`);
  }

  public showNew(id: string): Observable<Patient> {
    return this.http
      .get<PatientAPIResponse>(`${environment.apiUrl}/secretarias-patient/${id}`)
      .pipe(map((patientFHIR: PatientAPIResponse) => this.patientAdapter.adapterToModel(patientFHIR)));
  }

  public list() {
    return this.http.get(`${environment.apiUrl}/secretarias-patient`);
  }

  public listNew(): Observable<Patient[]> {
    return this.http
      .get<PatientAPIResponse[]>(`${environment.apiUrl}/secretarias-patient`)
      .pipe(map((patientsFHIR: PatientAPIResponse[]) => patientsFHIR.map((patient) => this.patientAdapter.adapterToModel(patient))));
  }
}
